import { IInstrumentLimitContext } from "@faire/web-api--source/indigofair/data/IInstrumentLimitContext";
import { IListRetailerInstrumentsRequest } from "@faire/web-api--source/indigofair/data/IListRetailerInstrumentsRequest";

/**
 * Helper function to get the initial list retailer instruments request. Needed so that
 * the prefetch request and the initial request are the same.
 */
export const getPrefetchedListRetailerInstrumentsRequest = () => {
  return IListRetailerInstrumentsRequest.build({
    context: IInstrumentLimitContext.build({
      surface: IInstrumentLimitContext.Surface.CHECKOUT,
      amount: undefined,
    }),
  });
};
